import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";
import Vehicle from "./vehicle-service.js";

export default class Recv {

    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
        this.vs = new Vehicle({ ctx: lib.ctx, router: lib.router });
    }

    pg_recv_vehicle_details(payload) {
        console.log(payload)
    }

    pg_recv_discounts(payload) {
        console.log(payload)
    }

    pg_recv_coverage_select(payload) {
        console.log(payload)
    }

    pg_recv_thanks(payload) {
        console.log(payload)
    }

}